export enum MDBPoolStatuses {
  ESCROW_REQUEST = 'ESCROW_REQUEST',
  CHANGER_PAYOUT_BUSY = 'CHANGER_PAYOUT_BUSY',
  NO_CREDIT = 'NO_CREDIT',
  DEFECTIVE_TUBE_SENSOR = 'DEFECTIVE_TUBE_SENSOR',
  DOUBLE_ARRIVAL = 'DOUBLE_ARRIVAL',
  ACCEPTOR_UNPLUGGED = 'ACCEPTOR_UNPLUGGED',
  TUBE_JAM = 'TUBE_JAM',
  ROM_CHECKSUM_ERROR = 'ROM_CHECKSUM_ERROR',
  COIN_ROUTING_ERROR = 'COIN_ROUTING_ERROR',
  CHANGER_BUSY = 'CHANGER_BUSY',
  CHANGER_WAS_RESET = 'CHANGER_WAS_RESET',
  COIN_JAM = 'COIN_JAM',
  POSSIBLE_CREDITED_COIN_REMOVAL = 'POSSIBLE_CREDITED_COIN_REMOVAL',
}
